import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const original = err.config;
    const status = err.response?.status;
    const url = original?.url || "";
    const publicPaths = ["/login", "/forgot-password", "/reset-password"];
    const onPublic = publicPaths.some((p) => window.location.pathname.startsWith(p));
    const skipRetry = url.includes("/auth/refresh") || url.includes("/auth/login") || url.includes("/auth/logout");

    // Access token expired: try a one-time refresh, then replay the request.
    if (status === 401 && original && !original._retry && !skipRetry) {
      original._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(original);
      } catch (e) {
        refreshing = null;
        if (!onPublic) window.location.href = "/login";
        return Promise.reject(e);
      }
    }
    return Promise.reject(err);
  }
);

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export async function runJob(startPromise, { interval = 3000, timeout = 240000 } = {}) {
  const { data } = await startPromise;
  const id = data.job_id;
  const start = Date.now();
  // eslint-disable-next-line no-constant-condition
  while (true) {
    await new Promise((r) => setTimeout(r, interval));
    const { data: j } = await api.get(`/jobs/${id}`);
    if (j.status === "done") return j.result;
    if (j.status === "error") throw new Error(j.error || "Generation failed");
    if (Date.now() - start > timeout) throw new Error("Timed out — please try again");
  }
}

export default api;
